import { Component, OnInit } from '@angular/core';
import { IMeshalem } from 'app/admin/interface/meshalem';
import { Validators, FormArray, FormBuilder } from '@angular/forms';
import { validateMsZehutControl } from 'app/shared/validators/ms-zehut-validator.validator';
import { IReservation } from 'app/admin/interface/ireservation';
import { Router } from '@angular/router';
import { AdminService } from 'app/admin/admin.service';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';
import { SpinnerService } from 'app/shared/spinner/spinner.service';
import { IDetailsForNofeshTashlumim } from 'app/admin/interface/idetails-for-nofesh-tashlumim.interface';


interface IKeyValue
{
  key: number;
  value: string;
}

@Component({
  selector: 'app-update-nofesh-payment',
  templateUrl: './update-nofesh-payment.component.html',
  styleUrls: ['./update-nofesh-payment.component.css']
})
export class UpdateNofeshPaymentComponent implements OnInit {

  meshalemArray: FormArray;
    meshalemArrayPrevious:FormArray;
    dolar_rate: number = 4;
    nofesh_title: string = "";
    id_nofesh: number = 0;
    shem_mazmin: string = "";
    ms_chadarim: number = 0;
    schum_tiul: number = 0;
    meshalmimList: IMeshalem[] = [];
    ms_zehut_valid_PaymentForm: boolean = true;
    is_oved_searched_PaymentForm: boolean = false;
    nofeshDeatils: IDetailsForNofeshTashlumim;
    selectedReservation: IReservation;
    ms_zehut_valid_TashlumForm: boolean = true;
    is_oved_searched_TashlumForm: boolean = false;
    isNofeshSelected: boolean = false;

    ofenTashlum = {
        salary: 1,
        credit: 2
    };

    get ms_zehut_mazmin_error() { return this.paymentForm.get('ms_zehut_mazmin'); }
    get ms_zehut_meshalem_error() { return this.tashlumForm.get('ms_zehut_meshalem'); }


    constructor(private _adminService: AdminService,
        private fb: FormBuilder,
        private _userMessages: UserMessagesService,
        private _spinnerService: SpinnerService,
        private _router:Router) { }

    ngOnInit() {
        //when coming from addNilve component
        
        let ms_zehut_mazmin_temp = sessionStorage.getItem('ms_zehut_mazmin');
        sessionStorage.clear();
        debugger
        if(ms_zehut_mazmin_temp!==null)
        {
            this.paymentForm.controls.ms_zehut_mazmin.patchValue(ms_zehut_mazmin_temp);
            let seacrhMsZehutMazminButton: HTMLElement = document.getElementById('searchNirshamim') as HTMLElement;
            seacrhMsZehutMazminButton.click();
        }
        
        //

        this.dolar_rate = 4;
    }
    nofeshTitles: IKeyValue[] = [
        { key: 0, value: "בחר" }
      ];
    paymentForm = this.fb.group({
        ms_zehut_mazmin: ['', Validators.compose([Validators.pattern("^[0-9]*$"), Validators.required])],
        nofeshTitle:[0],
    })


    tashlumForm = this.fb.group({
        meshalmimArray: this.fb.array([

        ])
    })


    getNofeshTitles(){
 
        this._spinnerService.showSpinner();
        this.clearFormArray(this.meshalemArray);
        this.isNofeshSelected = false;
        this.paymentForm.value.nofeshTitle = 0;
debugger;
        this.validateOvedmsZehutPaymentForm(this.paymentForm.value.ms_zehut_mazmin);
        this._adminService.GetNofeshAllNirshamimReservation(this.paymentForm.value.ms_zehut_mazmin).subscribe(response =>  {
            debugger;
            if(response.isSuccess)
            {
                let nofshonimReservations = response.data as IReservation[];
                this.nofeshTitles  = this._adminService.getNofeshTitles(response.data as IReservation[])
                 
                this.selectedReservation = nofshonimReservations.find(reservation => reservation.nirshamim[0].id_nofesh == this.paymentForm.value.nofeshTitle);
                   
            }
            else
            {
                this.is_oved_searched_PaymentForm = true;
            }
            
            this._spinnerService.hideSpinner();
        })
    }
           
         
    
    getNofshonPayment() {
       
        
        if (this.ms_zehut_valid_PaymentForm) {
            this._adminService.getDetailsForNofeshTashlumim(this.paymentForm.value.ms_zehut_mazmin,this.paymentForm.value.nofeshTitle).subscribe(res => {
                debugger;
                if (res.isSuccess) {
                    debugger;
                    this.id_nofesh = res.data.id_nofesh;
                    this.nofesh_title = res.data.nofesh_title;
                    this.shem_mazmin = res.data.shem_mazmin
                    this.ms_chadarim = res.data.ms_chadarim;
                    this.schum_tiul = res.data.schum;
                }
                else {
                    this.is_oved_searched_PaymentForm = true;
                }
            })
        }
    }

    getMeshalemList() {

        
        if (this.ms_zehut_valid_PaymentForm) {

            this._adminService.getMeshalemEmzaiTashlumNofesh( this.paymentForm.value.ms_zehut_mazmin,this.paymentForm.value.nofeshTitle).subscribe(res => {

                if (res.isSuccess) {
                    this.meshalmimList = res.data;
                    this.meshalmimList.forEach((meshalem) => {
                        this.meshalemArray = this.tashlumForm.get('meshalmimArray') as FormArray;
                        this.meshalemArrayPrevious = this.tashlumForm.get('meshalmimArray') as FormArray;
                        this.meshalemArray.push(this.fb.group({
                            
                            ms_zehut_meshalem: [meshalem.ms_zehut_meshalem, Validators.compose([Validators.pattern("^[0-9]*$"), Validators.required, validateMsZehutControl])],
                            ms_chadarim: [meshalem.ms_chadarim],
                            schum_tashlum: [meshalem.schum],
                            ofen_tashlum: [meshalem.ofen_tashlum],
                            ms_tashlumim: [meshalem.ms_tashlumim],
                            ms_zehut_meshalem_previous:[meshalem.ms_zehut_meshalem]
                        }))
                    })
                   Object.assign(this.meshalemArrayPrevious,this.meshalemArray);
                }
                else {
                    this.is_oved_searched_TashlumForm = true;
                }
            })
            
        }
    }
    clearFormArray = (formArray: FormArray) => {
        while (formArray!=null && formArray.length !== 0 ) {
          formArray.removeAt(0)
        }
      }
    getNofeshDataAndMeshalmim() {
        
        this.clearFormArray(this.meshalemArray);
        this.isNofeshSelected = true;
        this.getNofshonPayment();
        this.getMeshalemList();
    }

    validateOvedmsZehutPaymentForm(ms_zehut) {
     
        let valid_zehut = this.validatemsZehut(ms_zehut);
        if (valid_zehut) {
            this.ms_zehut_valid_PaymentForm = true;
        }
        else {
            this.ms_zehut_valid_PaymentForm = false;
            this.paymentForm.patchValue({ ms_zehut_mazmin: "" });
            return;
        }
    }
    validateOvedmsZehutTashlumimForm(ms_zehut) {
        let valid_zehut = this.validatemsZehut(ms_zehut);
        if (valid_zehut) {
            this.ms_zehut_valid_TashlumForm = true;
        }
        else {
            this.ms_zehut_valid_TashlumForm = false;
            this.paymentForm.patchValue({ ms_zehut_meshalem: "" });
            return;
        }
    }
    validatemsZehut(value) {

        if (value.length == 0)
            return false;

        var result = true;
        var first8 = null;
        var cifratBikoret = null;
        try {
            if (value.length == 10)
                first8 = value.substring(0, 9);
            else {
                if (value.length == 9)
                    first8 = "0" + value.substring(0, 8);
                else
                    first8 = "00" + value.substring(0, 8);
            }
            cifratBikoret = value.substring(value.length - 1);
            var checkDigits = 0 * 1;
            var temp = 0;
            var i = 0;

            for (i = 1; i <= 9; i++) {
                temp = first8.charAt(i - 1);
                checkDigits = temp * 1 + checkDigits * 1;
                if ((i % 2) == 1) {
                    checkDigits = temp * 1 + checkDigits * 1;
                    if (temp > 4)
                        checkDigits = checkDigits * 1 - 9;
                }
            }
            checkDigits = (10 - checkDigits % 10) % 10;
            result = (checkDigits * 1 == cifratBikoret * 1);
        }
        catch (e) { result = false; }
        if (value == "0")
            result = false;
        return result;
    }
    onMsZehutSearchChangePaymentForm(value: string) {
        this.is_oved_searched_PaymentForm = false;
    }
    onMsZehutSearchChangeTashlumimForm(value: string) {
        this.is_oved_searched_TashlumForm = false;
    }

    updateMeshalmim()
    {
        
        this._userMessages.clearAll();
        let meshalemList: IMeshalem[] = [];
        debugger;
        for(var index=0;index<this.meshalemArray.controls.length;index++)
        {
            var fg = this.meshalemArray.controls[index];
            console.log('fg: ',fg);
            meshalemList[index] = new IMeshalem();
            meshalemList[index].id_nofesh = this.paymentForm.value.nofeshTitle;
            meshalemList[index].ms_zehut_mazmin = this.paymentForm.value.ms_zehut_mazmin;
            meshalemList[index].ms_zehut_meshalem = fg.value.ms_zehut_meshalem;
            //meshalemList[index].ms_zehut_meshalem_previous = this.meshalemArrayPrevious.controls[index].value.ms_zehut_meshalem_previous;
            meshalemList[index].ms_zehut_meshalem_previous = fg.value.ms_zehut_meshalem_previous;
            meshalemList[index].schum = fg.value.schum_tashlum;
            meshalemList[index].ofen_tashlum = fg.value.ofen_tashlum;
            meshalemList[index].ms_tashlumim = fg.value.ms_tashlumim;
        }
        let errorResult: boolean = undefined;
        this._spinnerService.showSpinner();
        this._adminService.updateNofeshMeshalmim(meshalemList).subscribe(result => {
            for(let element of result)
            {
                if(element.isSuccess == false)
                {
                   
                    this._userMessages.setErrorMessage("בעיה בעדכון אחד או יותר מהמשלמים");
                }
                else
                {
                    this._userMessages.setSuccessMessage("משלמים עודכנו בהצלחה");
                }
            };

        })
        this._spinnerService.hideSpinner();
    }
    
// //special custom validator
// export function ValidateMsZehutControl(control: AbstractControl) {
// console.log(typeof control.value)
//     let value: string = String(control.value);
//     let result = { invalid_ms_zehut: false };
//     console.log(typeof value)

//     var first8 = null;
//     var cifratBikoret = null;
//     debugger;
//     try 
//     {
//         if (value.length == 10)
//             first8 = value.substring(0, 9);
//         else {
//             if (value.length == 9)
//                 first8 = "0" + value.substring(0, 8);
//             else
//                 first8 = "00" + value.substring(0, 8);
//         }
//         cifratBikoret = value.substring(value.length - 1);
//         var checkDigits = 0 * 1;
//         var temp = 0;
//         var i = 0;

//         for (i = 1; i <= 9; i++) {
//             temp = first8.charAt(i - 1);
//             checkDigits = temp * 1 + checkDigits * 1;
//             if ((i % 2) == 1) {
//                 checkDigits = temp * 1 + checkDigits * 1;
//                 if (temp > 4)
//                     checkDigits = checkDigits * 1 - 9;
//             }
//         }
//         checkDigits = (10 - checkDigits % 10) % 10;
//         result.invalid_ms_zehut = (checkDigits * 1 != cifratBikoret * 1);
//     }
//     catch (e) { result.invalid_ms_zehut = true; }
    
//     if (value == "0")
//     {
//         result.invalid_ms_zehut = true;
//     }

//     return result;
// }



}
